// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"43f62224d1ea7147","6831":"a3e09cb019322421","8503":"24ce6bb36ff25227","9683":"3037bedfc9b2d66d"}[chunkId] + ".js";
};